/* eslint-disable react-hooks/exhaustive-deps */
import React, { useEffect, useRef, useState } from "react";
import { SpeakingControls } from "../components/SpeakControls";
import SpeakRead from "../components/SpeakRead";
import SpeakFooter from "./SpeakFooter";
import SpeakPrepare from "../components/SpeakPrepare";
import { useMobileView } from "../components/MobileViewContext";
import {
  AccountType,
  TestStatus,
  SpeakingType,
} from "../../components/constants/constants";
import { AudioUrl, isSPEAKABC } from "../../libs/env";
import QuestionInfoPrepare from "../components/QuestionInfoPrepare";

const QuesSpeakingTypes = [
  SpeakingType.RESPOND_INFO_QUESTION,
  SpeakingType.RESPOND_QUESTION,
  SpeakingType.AUDIO_QUESTION,
];

const SpeakQuizBody = ({
  section,
  exercise,
  systemrequirementToggle,
  isReview,
  setIsonRecorder,
  isStopTimer,
  setIsStopTimer,
  setresetAudio,
  answers,
  section_id,
  page_id,
  data,
  creatQuizDataAndSubmit,
  setTestStatus,
  testStatus,
  isSubmitting,
  hasUserInteracted,
}) => {
  let { isMobileView } = useMobileView();
  const beepAudioref = useRef(null);
  const QuesInfoAudioref = useRef(null);
  const [isAudioUpload, setIsaudioUpload] = useState(false);
  const [startReadingtime, setstartReadingtime] = useState(false);
  const statuskey = `${data.student_assessment_id}${section_id}${exercise.id}`;

  useEffect(() => {
    if (localStorage.getItem(`taskstatus${statuskey}`)) {
      setTestStatus(localStorage.getItem(`taskstatus${statuskey}`));
    } else if (
      exercise.speaking_question_type === SpeakingType.RESPOND_INFO_QUESTION &&
      exercise.show_info_prepare_time
    ) {
      localStorage.setItem(`taskstatus${statuskey}`, TestStatus.INFO_PREPARE);
      setTestStatus(TestStatus.INFO_PREPARE);
    } else if (QuesSpeakingTypes.includes(exercise.speaking_question_type)) {
      localStorage.setItem(`taskstatus${statuskey}`, TestStatus.PLAY_QUES);
      setTestStatus(TestStatus.PLAY_QUES);
    }
  }, [statuskey, exercise]);

  const readQuesInfo = async () => {
    if (QuesInfoAudioref.current) {
      try {
        await QuesInfoAudioref.current.play();
        QuesInfoAudioref.current.onended = () => {
          QuesInfoAudioref.current.src = "";
          setTimeout(() => {
            setTestStatus(TestStatus.Prepare);
          }, 150);
        };
      } catch (error) {
        if (error.name === 'NotAllowedError' && !hasUserInteracted) {
          alert("Please click anywhere on the page to enable audio playback.");
        } else {
          setTestStatus(TestStatus.Prepare);
          console.error("Error playing audio:", error);
        }
      }
    } else {
      setTestStatus(TestStatus.Prepare);
    }
  };

  useEffect(() => {
    if (testStatus === TestStatus.PLAY_QUES) {
      setTimeout(() => {
        readQuesInfo();
      }, 1000);
    }
  }, [testStatus, hasUserInteracted]);

  const playbeepaudio = async () => {
    if (beepAudioref.current) {
      try {
        await beepAudioref.current.play();
      } catch (error) {
        console.error("Error playing audio:", error);
      }
    }
  };

  const handleScroll = (e) => {
    var timer;
    const container = e.target;
    if (container) {
      container.classList.add("scrollable_scroll");
    }
    clearTimeout(timer);
    timer = setTimeout(() => {
      container.classList.remove("scrollable_scroll");
    }, 800);
  };

  return (
    <>
      <div
        key={exercise.id}
        className={`d-flex flex-column ${
          isMobileView ? "sm-Speak-Quizbody" : "Speak-Quizbody"
        }`}
      >
        <div className="d-flex flex-column main-content container speak-content-width">
          {data.user_type === AccountType.STUDENT ? (
            <div className="flex-container">
              <h3 class="custom-heading">{section.section_name}</h3>
              {testStatus === TestStatus.Read ? (
                <SpeakRead
                  isStopTimer={isStopTimer}
                  setIsStopTimer={setIsStopTimer}
                  isReview={isReview}
                  data={data}
                  exercise={exercise}
                  section_id={section_id}
                  playbeepaudio={playbeepaudio}
                  isAudioUpload={isAudioUpload}
                  creatQuizDataAndSubmit={creatQuizDataAndSubmit}
                  setIsaudioUpload={setIsaudioUpload}
                  setstartReadingtime={setstartReadingtime}
                  startReadingtime={startReadingtime}
                  hasUserInteracted={hasUserInteracted}
                />
              ) : testStatus === TestStatus.Prepare ? (
                <SpeakPrepare
                  isStopTimer={isStopTimer}
                  isReview={isReview}
                  data={data}
                  exercise={exercise}
                  section_id={section_id}
                  setTestStatus={setTestStatus}
                  playbeepaudio={playbeepaudio}
                  setstartReadingtime={setstartReadingtime}
                  hasUserInteracted={hasUserInteracted}
                />
              ) : (
                testStatus === TestStatus.INFO_PREPARE && (
                  <QuestionInfoPrepare
                    isStopTimer={isStopTimer}
                    isReview={isReview}
                    data={data}
                    exercise={exercise}
                    section_id={section_id}
                    setTestStatus={setTestStatus}
                    playbeepaudio={playbeepaudio}
                    hasUserInteracted={hasUserInteracted}
                  />
                )
              )}
            </div>
          ) : (
            <div className="flex-container">
              <h3 class="custom-heading">{section.section_name}</h3>
            </div>
          )}
          <p class="regular-text py-3">{exercise.prompt_content}</p>
          <div
            onScroll={handleScroll}
            class="photo-description justify-content-center border  overflow-auto"
          >
            <div
              spellcheck="false"
              data-gramm="false"
              dangerouslySetInnerHTML={{
                __html: `${exercise.html_content
                  ?.replace(/\[\[.*?\]\]\.\s*/g, "")
                  .replace(/\[\[.*?\]\]\s*/g, "")}`,
              }}
            />
          </div>
          <div key={`${section.id}${exercise.id}`}>
            <SpeakingControls
              setIsaudioUpload={setIsaudioUpload}
              systemrequirementToggle={systemrequirementToggle}
              isStopTimer={isStopTimer}
              setIsonRecorder={setIsonRecorder}
              data_section_id={section_id}
              data_page_id={page_id}
              answers={answers}
              setresetAudio={setresetAudio}
              data_exercise_id={exercise.id}
              data_type={data.type}
              Studentname={data.school_student_id}
              testStatus={testStatus}
              startReadingtime={startReadingtime}
              isSubmitting={isSubmitting}
            />
          </div>
          <audio ref={beepAudioref} src={`${AudioUrl}/beep-audio.mp3`} playsInline={true} />
          {exercise.ques_info_audio && (
            <audio ref={QuesInfoAudioref} src={exercise.ques_info_audio} playsInline={true}  />
          )}
        </div>
       {!isSPEAKABC && (
        <div className={isMobileView ? ("col-12 sm-footer-bottom") : "col-10 sm-footer-bottom"}>
          <SpeakFooter />
        </div>
        )}
      </div>
    </>
  );
};

export default SpeakQuizBody;
